"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.alignOn = alignOn;
exports.ceil = ceil;
exports.floor = floor;
exports.alignOnHalf = alignOnHalf;
exports.alignOnQuarter = alignOnQuarter;
exports.getTimeWindow = getTimeWindow;
exports.getPickUpDeadlines = getPickUpDeadlines;
var moment_1 = __importDefault(require("@ambler/moment"));
var transport_reasons_1 = require("../transport-reasons");
function alignOn(dateTime, stepInMinutes) {
    var alignedDatetime = (0, moment_1.default)(dateTime);
    if (alignedDatetime.minutes() % stepInMinutes !== 0) {
        // Normalize "from" to be on round hours
        var minutes = alignedDatetime.minutes();
        minutes += stepInMinutes - (minutes % stepInMinutes);
        alignedDatetime.minutes(minutes);
        alignedDatetime.seconds(0);
        alignedDatetime.milliseconds(0);
    }
    return alignedDatetime.startOf('m');
}
function ceil(datetime, step) {
    var value = (0, moment_1.default)(datetime);
    var minutes = value.minutes();
    var rest = minutes % step;
    if (rest !== 0) {
        value.minutes(value.minute() + (step - rest));
    }
    return value.startOf('minute');
}
function floor(datetime, step) {
    var value = (0, moment_1.default)(datetime);
    var minutes = value.minutes();
    var rest = minutes % step;
    if (rest !== 0) {
        value.minutes(value.minute() - rest);
    }
    return value.startOf('minute');
}
function alignOnHalf(dateTime) {
    return alignOn(dateTime !== null && dateTime !== void 0 ? dateTime : (0, moment_1.default)(), 30);
}
function alignOnQuarter(dateTime) {
    return alignOn(dateTime !== null && dateTime !== void 0 ? dateTime : (0, moment_1.default)(), 15);
}
function getTimeWindow(_a) {
    var currentDate = _a.currentDate, timezone = _a.timezone, reason = _a.reason, isPastOrder = _a.isPastOrder, outboundDate = _a.outboundDate;
    var times = [];
    var TIME_STEP = transport_reasons_1.reasonRules.timeStepInMinutes(reason);
    if (!TIME_STEP) {
        return [];
    }
    var isToday = (0, moment_1.default)(currentDate).isSame((0, moment_1.default)(), 'day');
    var from = (function () {
        if (isPastOrder) {
            if (outboundDate && (0, moment_1.default)(currentDate).isSame(outboundDate, 'day')) {
                return (0, moment_1.default)(outboundDate).tzProtected(timezone).add(TIME_STEP, 'minutes');
            }
            return (0, moment_1.default)(currentDate).tzProtected(timezone).startOf('d');
        }
        if (isToday) {
            return alignOnQuarter((0, moment_1.default)().tzProtected(timezone).add(75, 'm'));
        }
        return (0, moment_1.default)(currentDate).tzProtected(timezone).startOf('d');
    })();
    var to = (function () {
        if (isPastOrder && isToday && !outboundDate) {
            return (0, moment_1.default)().tzProtected(timezone);
        }
        return (0, moment_1.default)(currentDate).tzProtected(timezone).endOf('d');
    })();
    var diffInMinutes = (0, moment_1.default)(to).diff(from, 'm');
    var steps = Math.round(diffInMinutes / TIME_STEP);
    for (var step = 0; step < steps; step++) {
        var stepped = (0, moment_1.default)(from).add(step * TIME_STEP, 'm');
        var diffInSeconds = (0, moment_1.default)(currentDate).diff(stepped, 's');
        if (diffInSeconds > 0 && diffInSeconds < 60) {
            // * Push current deadline rather than a different moment
            // * at the same minute but different seconds
            times.push((0, moment_1.default)(currentDate));
        }
        else if (diffInSeconds >= 60 && diffInSeconds < TIME_STEP * 60) {
            // * If deadline is within 15 minutes of a step
            // * display both options
            times.push(stepped);
            times.push((0, moment_1.default)(currentDate));
        }
        else {
            times.push(stepped);
        }
    }
    return times.map(function (time) { return time.toISOString(); });
}
function getPickUpDeadlines(timezone) {
    var times = [];
    var from = timezone ? alignOnHalf((0, moment_1.default)().tzProtected(timezone).add(45, 'm')) : alignOnHalf((0, moment_1.default)().add(45, 'm'));
    for (var step = 0; step < 5; step++) {
        times.push((0, moment_1.default)(from).add(step * 30, 'm'));
    }
    return times;
}
//# sourceMappingURL=datetime.js.map